// Init i18next — appelé depuis main.tsx avant le premier render (offline-first :
// la langue doit être résolue dès le boot, sans dépendre du réseau, toutes les
// ressources étant embarquées dans le bundle).
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import fr from "../locales/fr.json";
import en from "../locales/en.json";
import ptPT from "../locales/pt-PT.json";
import pl from "../locales/pl.json";
import ro from "../locales/ro.json";

/** FR est le catalogue canonique : toute nouvelle clé doit y être ajoutée en premier. */
export const SUPPORTED_LANGUAGES = ["fr", "en", "pt-PT", "pl", "ro"] as const;
export type SupportedLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const LANGUAGE_STORAGE_KEY = "poseurs-lang";

export const LOCALE_RESOURCES = {
  fr,
  en,
  "pt-PT": ptPT,
  pl,
  ro,
} as const satisfies Record<SupportedLanguage, unknown>;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: Object.fromEntries(
      SUPPORTED_LANGUAGES.map((lng) => [lng, { translation: LOCALE_RESOURCES[lng] }]),
    ),
    fallbackLng: "fr",
    supportedLngs: SUPPORTED_LANGUAGES,
    nonExplicitSupportedLngs: false,
    interpolation: { escapeValue: false },
    detection: {
      // localStorage d'abord (choix explicite persistant), puis la langue du
      // navigateur. Toute résolution passe par `caches` qui réécrit le choix
      // dans localStorage à chaque changement (LanguageSwitcher inclus).
      order: ["localStorage", "navigator"],
      lookupLocalStorage: LANGUAGE_STORAGE_KEY,
      caches: ["localStorage"],
    },
  });

export default i18n;
